import React from 'react';
import CustomAddPage from 'components/custom-pages/CustomAddPage';

const Add = ({ data, handleClick }) => {
  const initialValues = {
    name: data?.name || '',
  };

  const inputFields = [
    {
      name: 'name',
      label: 'Inspection Actionable',
      type: 'text',
      required: true,
    },
  ];

  return (
    <CustomAddPage
      pageTitle={
        data ? 'Update Inspection Actionable' : 'Add Inspection Actionable'
      }
      url={'inspection-actionable'}
      action={!data ? 'create' : 'update'}
      updateId={data?._id}
      queryKey="inspection-actionable"
      inputFields={inputFields}
      data={initialValues}
      handleClick={handleClick}
    />
  );
};

export default Add;
